import { IMAGES } from "../../data/content";

export const Header = () => (
  <header
    data-testid="site-header"
    className="border-b border-neutral-800 bg-neutral-950/95 backdrop-blur sticky top-0 z-50"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
      <a href="#top" data-testid="header-logo" className="flex items-center gap-3">
        <span className="w-3 h-3 bg-red-600 inline-block" />
        <img
          src={IMAGES.logoWhite}
          alt="Legend Team"
          className="h-6 sm:h-7 w-auto"
        />
      </a>
      <nav className="hidden md:flex items-center space-x-6 text-xs uppercase tracking-widest font-bold text-neutral-400">
        <a data-testid="nav-storia" href="#capitolo-1" className="hover:text-red-500 transition-colors">01. Storia</a>
        <a data-testid="nav-media" href="#capitolo-2" className="hover:text-red-500 transition-colors">02. Media & Sponsor</a>
        <a data-testid="nav-club" href="#capitolo-3" className="hover:text-red-500 transition-colors">03. Club & Village</a>
        <a data-testid="nav-academy" href="#capitolo-4" className="hover:text-red-500 transition-colors">04. Academy</a>
      </nav>
      <a
        data-testid="header-cta"
        href="#contact"
        className="px-4 py-2 border border-red-600 text-red-500 hover:bg-red-600 hover:text-white text-xs uppercase tracking-widest font-bold transition-colors"
      >
        Contatta la Scuderia
      </a>
    </div>
  </header>
);
